import NavbarHomeNavigation from '@/layouts/navigation/components/NavbarHomeNavigation';
import SuarteName from '@/shared-components/icons/components/public/SuarteName';

import './styles/HomeNavigation.css';

export default function HomeNavigation({ active }) {
  return (
    <>
      <div className="home-navigation__container">
        <SuarteName className="home-navigation__suarte-name"/>
        <NavbarHomeNavigation active={active} />
      </div>
    </>
  );
}
